import React from 'react';
import loadable from '@loadable/component';

import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';

const AnimateHeight = loadable(() => import('react-animate-height'));

const ProductClearAllFiltersButton = ({ canClear, clearRefinement }) => (
  <AnimateHeight duration={300} height={canClear ? 'auto' : 0} animateOpacity>
    <div className="md:pb-5">
      <ClearAllFiltersButton onClick={clearRefinement}>
        Clear all
      </ClearAllFiltersButton>
    </div>
  </AnimateHeight>
);

export default ProductClearAllFiltersButton;
